module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJoAAABMCAIAAAAa+jlyAAABF0lEQVR4Ae3TAREAIAzDwIJ/z+Aj93OQZD1vrmPgdlCQbHKmvkBOOVMGUjDWKWfKQArGOuVMGUjBWKecKQMpGOuUM2UgBWOdcqYMpGCsU86UgRSMdcqZMpCCsU45UwZSMNYpZ8pACsY65UwZSMFYp5wpAykY65QzZSAFY51ypgykYKxTzpSBFIx1ypkykIKxTjlTBlIw1ilnykAKxjrlTBlIwVinnCkDKRjrlDNlIAVjnXKmDKRgrFPOlIEUjHXKmTKQgrFOOVMGUjDWKWfKQArGOuVMGUjBWKecKQMpGOuUM2UgBWOdcqYMpGCsU86UgRSMdcqZMpCCsU45UwZSMNYpZ8pACsY65UwZSMFYp5wpAykY60zl/EvfAZeLhCQNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/27.png
// module id = Goqu
// module chunks = 1